import {I18n} from 'react-i18nify';
import contentDefinitionTypes from '../../config/contentDefinitionTypes';

const initialState = {
    items: [],
    select: [],
    selectPages: [],
    selectBlocks: []
};

export default (state = initialState, action) => {
    switch (action.type) {

        case 'GLOBALS_RESET':
            return initialState;
            
        case 'GET_GLOBALS':
            const select = [];
            const selectPages = [];
            const selectBlocks = [];
            let items = [];

            if (action.payload.contentDefinitions){
                action.payload.contentDefinitions.forEach((contentDefinition) => {

                    if (contentDefinitionTypes[contentDefinition.contentDefinitionType].type === 'Block') {
                        selectBlocks.push({
                            id: contentDefinition.id,
                            title: I18n.t('block.' + contentDefinition.key)
                        });
                        } else if (contentDefinitionTypes[contentDefinition.contentDefinitionType].type === 'Page') {
                        selectPages.push({
                            id: contentDefinition.id,
                            title: I18n.t('content.' + contentDefinition.key)
                        });
                    }

                    select.push({
                        id: contentDefinition.id,
                        title: contentDefinition.key
                    });
                });
                items = action.payload.contentDefinitions;
            }

            return {
                ...state,
                items: items,
                select: select,
                selectPages: selectPages,
                selectBlocks: selectBlocks
            };
            
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/core/admin/store/reducers/contentdefinition.js